
import { React, theme } from "aaa";
import * as ReactDOM from "react-dom";
import { NativePaper } from "./NativePaper";

export const NativeModal = (props: {
    open: boolean;
    contentStyle?: React.CSSProperties;
    paperStyle: React.CSSProperties;
    bodyStyle: React.CSSProperties;
    children: any;
    "aria-label"?: string;
}) => {
    let containerRef: any = React.useRef(null);

    // Passing no second parameter = componentDidUpdate
    React.useEffect(() => {
        // Stop scrolling of background
        if (props.open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        // Cleanup
        return () => {
            document.body.style.overflow = "";
        };
    });

    const content = (
        <div
            className="theme-modal-overlay"
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                opacity: props.open ? 1 : 0,
                transition: "opacity 0.2s",
                zIndex: 1500,
                pointerEvents: props.open ? "auto" : "none"
            }}
            role="dialog"
            aria-modal={props.open}
            ref={containerRef}
            aria-label={props["aria-label"]}
        >
            <div
                style={{
                    transform: props.open ? "translate(0, 64px)" : "translate(0, -64px)",
                    margin: "0px auto",
                    boxSizing: "border-box",
                    transition: "transform 0.2s",
                    maxWidth: theme.MAX_APP_WIDTH,
                    width: "95%",
                    ...props.contentStyle
                }}
            >
                <NativePaper
                    style={{
                        overflowY: "hidden",
                        ...props.paperStyle
                    }}
                >
                    <div
                        style={{
                            padding: 24,
                            boxSizing: "border-box",
                            maxHeight: "80vh",
                            overflowY: "auto",
                            textAlign: "start",
                            ...props.bodyStyle
                        }}
                    >
                        {props.open && props.children}
                    </div>
                </NativePaper>
            </div>

        </div>
    );

    const portalRoot = document.getElementById("modal-root");
    if (portalRoot) {
        return ReactDOM.createPortal(content, portalRoot);
    } else {
        return content;
    }
};



// WEBPACK FOOTER //
// ./src/components/common/NativeModal.tsx